module.exports = __webpack_public_path__ + "images/audi_small45ae689aebbf24799795e25c9d76b912.png";